<section class="partners__wrapper">
  <div class="partners__title">Nasi partnerzy</div>
  <div class="container">
    <div class="partners__block">
      <div class="partners__logo-wrapper bg-transparent babolat">
        <a href="https://babolat-tenis.pl/225-padel" target="_blank">
          <img src="assets/images/partners/LOGO_BABOLAT_150TH.png" alt="Babolat" />
        </a>
      </div>
      <div class="partners__logo-wrapper bg-transparent tretorn">
        <a href="https://babolat-tenis.pl/4740-pilki-tretorn-serie-padel-control-x3.html" target="_blank">
          <img src="assets/images/partners/tretorn-logo.svg" alt="Tretorn" />
        </a>
      </div>
      <div class="partners__logo-wrapper bg-white plt">
        <a href="https://polskaligatenisa.pl/" target="_blank">
          <img src="assets/images/partners/plt-logo.png" alt="Polska Liga Tenisa" />
        </a>
      </div>
    </div>
  </div>
</section>
